<template>
  <div class="list">
    <div class="topBar">
      <div class="subTitle">
        <i
          class="far fa-window-minimize"
          style="transform:rotate(90deg);margin-right: -10px;color:rgba(52,152,219,1);"
        ></i>
        用户列表
        <div class="rutun">
          <div>
            <i class="fas fa-sync-alt"></i>
          </div>
          <div style="margin-left:4px" @click="geting()">刷新</div>
        </div>
      </div>
    </div>
    <noAccess v-if="showNoAccess"></noAccess>
    <div v-else  style="width: 1056px;margin: 0 auto">
      <div class="form-title">
        <div style="float: left;line-height: 46px;padding-left: 10px;">筛选查询</div>
      </div>
      <div class="search-box">
        <el-row class="search" :gutter="10">
          <el-col :span="3">
            <div class="label">用户账号:</div>
          </el-col>
          <el-col :span="4">
            <el-input v-model="mobile" clearable size="small" placeholder="用户账号"></el-input>
          </el-col>
          <el-col :span="3">
            <div class="label">用户姓名:</div>
          </el-col>
          <el-col :span="4">
            <el-input v-model="nickname" clearable size="small" placeholder="用户姓名"></el-input>
          </el-col>
          <el-col :span="3">
            <div class="label">手机号:</div>
          </el-col>
          <el-col :span="4">
            <el-input v-model="phone" clearable size="small" placeholder="手机号"></el-input>
          </el-col>
          <el-col :span="3">
            <div class="label">注册时间:</div>
          </el-col>
          <el-col :span="4">
            <template>
              <div class="block">
                <el-date-picker clearable v-model="create_time" size="small" placeholder="请选择时间"></el-date-picker>
              </div>
            </template>
          </el-col>
          <el-col :span="6" align="center">
            <div class="filtrate_seek_sousuo" @click="geting()">搜索</div>
          </el-col>
        </el-row>
      </div>
      <div class="filtrate_center">
        <div class="center_list_head">
          <div class="center_list_head_left">
            <div>
              <i class="fas fa-bars"></i>
            </div>
            <div>数据列表</div>
          </div>
          <div class="center_list_head_rig" @click="dialogFormVisible1 = true">添加用户</div>
        </div>
        <div class="center_list_center"></div>
      </div>
      <el-table :data="tableData" border style="width: 100%" ref="multipleTable">
        <el-table-column width="180" label="用户账号" align="center">
          <template slot-scope="scope">
            <router-link :to=" '/admin/y_userLook/' + scope.row.mobile + '/1'">
              <el-link>{{scope.row.mobile}}</el-link>
            </router-link>
          </template>
        </el-table-column>
        <el-table-column label="用户姓名" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.remark_name != ''">{{scope.row.remark_name}}</span>
            <span v-else>{{scope.row.nickname}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="create_date" width="170" label="注册时间" align="center"></el-table-column>
        <el-table-column label="收货信息" align="center" width="400">
          <template slot-scope="scope">
            <span v-if="scope.row.address == ''">暂无收货信息</span>
            <span v-else>
              {{scope.row.address.name}}/
              {{scope.row.address.mobile}}/
              {{scope.row.address.province + scope.row.address.city+ scope.row.address.area + scope.row.address.address}}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="150" align="center" name="bianji">
          <template slot-scope="scope" style="display:flex;padding:0;margin:0">
            <button @click="red(scope.row.mobile,1)" class="button1">查看</button>
            <button @click="showRemark = true,remarkMobile = scope.row.mobile" class="button1">备注</button>
            <button @click="deladmin(scope.row.mobile)" class="button1">删除</button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pager" v-if="total > 15">
        <div class="page_box">
          <el-pagination
          background
          layout="prev, pager, next"
          :total="total"
          :page-size="15"
          @current-change="setPage"
        ></el-pagination>
        </div>
      </div>
    </div>
    <!-- 添加用户 -->
    <el-dialog title="添加账户" :visible.sync="dialogFormVisible1" width="33%">
      <el-form>
        <el-form-item label="用户账号:">
          <el-input style="width:356px" v-model="odd" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="输入密码:">
          <el-input style="width:356px" type="password" v-model="password" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="确认密码:">
          <el-input style="width:356px" type="password" v-model="password1" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible1 = false">取 消</el-button>
        <el-button type="primary" @click="submit()">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="备注账号" :visible.sync="showRemark" width="33%">
      <el-form>
        <el-form-item label="用户账号:">
          <el-input style="width:356px" v-model="remarkMobile" :disabled="true" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="备注名称:">
          <el-input style="width:356px" v-model="remarkName" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showRemark = false">取 消</el-button>
        <el-button type="primary" @click="remark_name()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "list",
  data() {
    return {
      serve: this.$store.state.serve,
      showNoAccess:false,
      token: this.$cookies.get("token"),
      username: this.$cookies.get("username"),
      page: null,
      total: 0,
      tableData: [],
      mobile: "",
      phone: "",
      create_time: "",
      nickname: "",
      odd: "",
      password: "",
      password1: "",
      value2: true,
      dialogFormVisible1: false,
      id: "",
      mobile: "",
      number: "",
      name: "",
      value1: "",
      resType: null,
      option: [],
      value: "",
      name: null,
      category: null,
      categorys: [],
      brand: null,
      brands: [],
      multipleSelection: [],
      isIndeterminate: true,
      select: false,
      selectAll: false,
      checked: [],
      idString: "",
      showRemark: false,
      remarkMobile: "",
      remarkName: ""
    };
  },
  created() {
    this.$store.state.topActiveId = 4;
    this.$store.state.leftTitle = "用户列表";
    this.geting();
  },
  watch: {
    //监听全选状态
    selectAll(v) {
      if (v == false) {
        this.$refs.multipleTable.clearSelection();
      } else {
        this.$refs.multipleTable.clearSelection();
        this.$refs.multipleTable.toggleAllSelection();
      }
    }
  },
  methods: {
    alert_success(message) {
      this.$message({
        type: "success",
        message: message,
        offset: 200
      });
    },
    alert_error(message) {
      this.$message({
        type: "error",
        message: message,
        offset: 200
      });
    },
    remark_name() {
      this.axios
        .get(this.serve + "/admin/updateUserRemarkName", {
          params: {
            username: this.username,
            token: this.token,
            mobile: this.remarkMobile,
            name: this.remarkName
          }
        })
        .then(res => {
          var data = res.data;
          if (data.status == "success") {
            this.geting();
            this.alert_success("备注成功!");
            this.showRemark = false;
            this.remarkName = "";
          }else if(res.data.code == '403'){
            this.$message.error(res.data.msg); 
          } else {
            this.alert_error("备注失败!");
            this.remarkName = "";
          }
        });
    },
    deladmin(v) {
      this.$confirm("此操作将永久删除该文件, 是否继续?", "删除用户", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.axios
            .get(this.serve + "/admin/delete_home_user", {
              params: {
                token: this.token,
                username: this.username,
                mobile: v
              }
            })
            .then(res => {
              if (res.data.status == "success") {
                this.$message({
                  type: "success",
                  message: "删除成功!"
                });
                this.geting();
              }else{
                this.$message.error(res.data.msg); 
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    open4() {
      //错误时返回的息状态
      this.$message.error("添加失败");
    },
    open() {
      this.$message({
        //成功时 返回的状态
        message: "添加成功",
        type: "success"
      });
    },
    submit(id) {
      //弹窗提交
      for (var key in this.tableData) {
        if (this.odd === this.tableData[key].mobile) {
          this.$message.error("此账号已存在");
          return;
        }
      }
      if (this.odd == "") {
        this.$message.error("请输入用户账号");
        return;
      } else if (this.odd !== "") {
        var cel = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
        if (!cel.test(this.odd)) {
          this.$message.error("账号为手机号码");
          return;
        }
      }
      if (this.password == "") {
        this.$message.error("请输入密码");
        return;
      } else if (this.password !== "") {
        var pass = /^[A-Za-z0-9]{6,20}$/;
        if (!pass.test(this.password)) {
          this.$message.error("登陆密码最小为6位数，最大为20位数");
          return;
        }
      }
      if (this.password1 != this.password) {
        this.$message.error("两次输入密码不一致");

        return;
      }
      if (this.odd || this.password || this.password1) {
        this.dialogFormVisible1 = false;
      }
      const _this = this;

      this.axios
        .get(this.serve + "/admin/create_home_user", {
          params: {
            username: this.username,
            token: this.token,
            mobile: this.odd,
            password: this.password,
            new_pass: this.password1
          }
        })
        .then(res => {
          if (res.data.status == "success") {
            _this.open();
            _this.geting();
          }else if(res.data.code == '403'){
            this.$message.error(res.data.msg); 
          }else if (res.data.status == "error") {
            _this.open4();
          }
        });
    },
    red(id, s) {
      this.$router.push({
        path: "y_userLook/" + id + "/" + s
      });
    },
    setPage(v) {
      //分页

      this.page = v;
      this.geting(v);
      this.selectAll = false;
    },

    geting(page) {
      //请求数据
      const loading = this.$loading({
        lock: true,
        text: "正在加载...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      var that = this;
      this.username = this.$cookies.get("username");
      this.token = this.$cookies.get("token");
      this.axios
        .get(this.serve + "/admin/home_user_list", {
          params: {
            token: this.token,
            username: this.username,
            mobile: this.mobile,
            nickname: this.nickname,
            phone: this.phone,
            create_date: this.create_time,
            page: page ? page : this.page
          }
        })
        .then(res => {
          if(res.data.msg == '无权访问')
          {
            this.showNoAccess = true
          }
          that.tableData = [];
          var json = res.data.data;
          if (json) {
            that.total = res.data.data.total;
            that.page = res.data.data.page;
            for (var key in json.results) {
              var time = json.results[key].create_date;
              var timeNew = new Date(parseInt(time) * 1000)
                .toLocaleString()
                .replace(/:\d{1,2}$/, " ");

              json.results[key].create_date = timeNew;
              if (json.results[key].is_host == "1") {
                json.results[key].is_host = "主账户";
              } else if (json.results[key].is_host == "0") {
                json.results[key].is_host = "普通账户";
              }
              that.tableData.push(json.results[key]);
            }
          }
          loading.close();
        });
    }
  }
};
</script>
<style lang="scss">
.list {
  .pager {
    height: 30px;
  }
  .page_box {
    float: right;
  }
  background: #f5f5f5;
  color: #333;
  padding-bottom: 100px;
  min-height: 1000px;
  .topBar {
    margin-bottom: 40px;
  }
  .search-box {
    width: 1054px;
    height: 86px;
    background: rgba(255, 255, 255, 1);
    border: 1px solid rgba(221, 221, 221, 1);
  }
  .filtrate_seek_sousuo {
    text-align: center;
    line-height: 28px;
    font-size: 14px;
    font-family: "MicrosoftYaHeiLight";
    font-weight: 300;
    color: rgba(102, 102, 102, 1);
    width: 74px;
    height: 28px;
    background: rgba(255, 255, 255, 1);
    border: 1px solid rgba(221, 221, 221, 1);
    position: absolute;
    right: 18px;
    top: 29px;
    cursor: pointer;
  }
  .el-pagination {
    text-align: left;
  }
  .filtrate_seek_sousuo:hover {
    background-color: #0099ff;
    color: #fff;
  }
  .subTitle {
    width: 1056px;
    margin: 0 auto;
    font-size: 14px;
    position: relative;
    .rutun {
      width: 78px;
      height: 28px;
      background: #fff;
      border: 1px solid rgba(221, 221, 221, 1);
      text-align: center;
      margin-top: 9px;
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      right: 0;
      top: 0;
      cursor: pointer;
    }
    .rutun:hover {
      color: #0099ff;
    }
  }
  .filtrate_center {
    margin-top: 19px;
    border-left: 1px solid rgba(221, 221, 221, 1);
    border-top: 1px solid rgba(221, 221, 221, 1);
    border-right: 1px solid rgba(221, 221, 221, 1);
  }
  .button1 {
    // border: 0;
    border: none;
    outline: none;
    background: none;
    font-size: 14px;
    font-family: "MicrosoftYaHeiLight";
    font-weight: 300;
    color: rgba(51, 51, 51, 1);
    line-height: 18px;
    cursor: pointer;
  }
  .button1:hover {
    color: #0099ff;
  }
  .el-row {
    display: flex;
    justify-content: center;
  }
  .cell {
    color: #606266 !important;
  }
  .center_list_head {
    width: 100%;
    height: 46px;
    // background: orange;
    display: flex;
    justify-content: space-between;
    .center_list_head_left {
      display: flex;
      align-items: center;
      > div {
        margin-left: 10px;
      }
    }
    .center_list_head_rig {
      width: 100px;
      height: 30px;
      background: rgba(255, 255, 255, 1);
      border: 1px solid rgba(221, 221, 221, 1);
      font-size: 12px;
      font-family: "MicrosoftYaHeiLight";
      font-weight: 300;
      color: rgba(153, 153, 153, 1);
      margin: 7px 30px 0 0;
      line-height: 30px;
      text-align: center;
      cursor: pointer;
    }
    .center_list_head_rig:hover {
      color: #0099ff;
    }
  }

  .menu {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
    .btn3 {
      i {
        font-style: normal;
        color: #f64e62;
      }
    }
    .btn3:hover i {
      color: #fff;
    }
  }
  .search .el-col {
    line-height: 80px;
  }
  .label {
    text-align: right;
    padding-right: 10px;
    font-size: 14px;
  }
  .table {
    background-color: #fff;
    padding: 10px 20px;
    .el-tree-node {
      font-size: 16px;
      padding: 5px 0;
    }
  }
  .el-table_1_column_3 .cell {
    overflow: hidden;
    text-align: center;
  }
}
</style>